import { Icon } from '@design/components/icon/Icon';
import clsx from 'clsx';
import React, { Dispatch, Fragment } from 'react';

import { NonLinearStepType } from '../NonLinearStepper';
import styles from './NonLinearStepRevamp.module.scss';

interface NonLinearStepRevampProps {
  index: number;
  step: NonLinearStepType;
  activeIndex?: number;
  iconSize: number;
  shouldHighlightStep: boolean;
  indexErrorMap: Record<number, boolean>;
  setIndexErrorMap: Dispatch<
    React.SetStateAction<{
      [key: number]: boolean;
    }>
  >;
}

export const NonLinearStepRevamp = ({
  index,
  activeIndex,
  step,
  iconSize,
  shouldHighlightStep,
  indexErrorMap,
  setIndexErrorMap,
}: NonLinearStepRevampProps) => {
  const { hoverLabel, logoUrl, imgNode, connectorLabel, iconColor } = step;
  const isActiveStep = index === activeIndex;

  const sizeStyle = { minWidth: iconSize, height: iconSize };

  return (
    <Fragment>
      <div className={styles.stepColumn}>
        {imgNode ? (
          <div
            className={styles.customLogo}
            aria-current={isActiveStep ? 'step' : undefined}
            data-testid={`step-${hoverLabel}`}
            style={{
              ...sizeStyle,
              ...(iconColor ? { backgroundColor: iconColor } : undefined),
            }}
          >
            {imgNode}
          </div>
        ) : indexErrorMap[index] || !logoUrl ? (
          <div
            className={clsx(styles.fallbackLogo, {
              [styles.active]: shouldHighlightStep,
            })}
            aria-current={isActiveStep ? 'step' : undefined}
            data-testid={`step-${hoverLabel}`}
            style={{
              ...sizeStyle,
              ...(iconColor ? { backgroundColor: iconColor } : undefined),
            }}
          >
            {hoverLabel.charAt(0).toUpperCase()}
          </div>
        ) : (
          <img
            className={styles.stepLogo}
            aria-current={isActiveStep ? 'step' : undefined}
            data-testid={`step-${hoverLabel}`}
            key={index}
            onError={() =>
              setIndexErrorMap(prev => ({ ...prev, [index]: true }))
            }
            src={logoUrl}
            alt={hoverLabel}
            width={iconSize}
            height={iconSize}
            style={{
              ...sizeStyle,
              ...(iconColor ? { backgroundColor: iconColor } : undefined),
            }}
          />
        )}
        {step.title && (
          <div className={styles.stepNameWrapper}>
            <p className={styles.stepName}>{step.title}</p>
          </div>
        )}
      </div>
      {connectorLabel && (
        <div className={styles.connector}>
          <div
            className={styles.connectorSpacer}
            style={{ width: iconSize, height: iconSize }}
            aria-hidden
          />
          <div className={styles.connectorContent}>
            <span className={styles.connectorLabel}>{connectorLabel}</span>
            <Icon
              iconName="ArrowRightConnector"
              className={styles.connectorArrow}
              width={85}
              height={12}
              viewBox="0 0 85 12"
              fillColor="var(--icon-disabled)"
              aria-hidden
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};
